/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useContext } from 'react';

import { actionTypes, CardContext } from '../CardContext';
import CardMenuAction from './CardMenuAction';
import CardEditAction from './CardEditAction';
import CardLinkAction from './CardLinkAction';
import CardDeleteAction from './CardDeleteAction';

export default function CardActions({ id }) {
  const { actionType, readOnly, handleEdit, handleDelete, sectionName, actions } = useContext(CardContext);
  const action = actions?.find(_action => _action?.type === actionType);
  if (readOnly || action?.readOnly) return null;

  switch (actionType) {
    case actionTypes.MENU:
      return handleEdit || handleDelete ? <CardMenuAction id={id} /> : null;
    case actionTypes.EDIT:
      return <CardEditAction />;
    case actionTypes.LINK:
      return <CardLinkAction sectionName={sectionName} />;
    case actionTypes.DELETE:
      return <CardDeleteAction />;
    default:
      return null;
  }
}
